import { render, staticRenderFns } from "./productMainInformationUpdate.vue?vue&type=template&id=0f10bda2&scoped=true"
import script from "./productMainInformationUpdate.vue?vue&type=script&lang=js"
export * from "./productMainInformationUpdate.vue?vue&type=script&lang=js"
import style0 from "./productMainInformationUpdate.vue?vue&type=style&index=0&id=0f10bda2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10bda2",
  null
  
)

export default component.exports